import './services/environment';
import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';

import { Provider } from 'react-redux';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { I18nextProvider } from 'react-i18next';

import store from './store';
import keycloak from './services/keycloak';
import i18n from './services/translations';

import App from './app';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <ReactKeycloakProvider authClient={keycloak}>
          <App />
        </ReactKeycloakProvider>
      </I18nextProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
